// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1UBvE","location":"Header_location__32Qpj"};